import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoadArchiveConfigurableDaysSetting, LoadOrgName, UpdateSettings } from '../../actions';
import Config from '../../config';
import setToast from '../../helpers/toaster.helper';
import { ArchiveConfigurableDaysSetting, mapToTimeZoneModel, Setting, SettingsModel, TimeZoneModel } from '../../models/settings-model';
import * as selector from '../../selectors/selectors';
import { SettingsService } from '../../services/SettingsService';
import { UserService } from '../../services/UserService';
import { UtilityService } from '../../services/UtilityService';
import { AppRoutes } from '../routes/route.path';
import ButtonComponent from '../shared/button/button.component';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, appNote, buttonLabels, ToasterTexts, ViewTextLabels } from '../shared/constants';
import CustomSwitch from '../shared/switch.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import SettingsCounterComponent from './settings-counter-component';
import SettingsHeader from './settingsHeader.component';
import { useThemeContext } from "../theme/ThemeContext";
import { UserPlanTracker } from "../../models/plan-metrics.model";
import { CancelIcon } from "../../icon";

let timeZonesTypes = UtilityService.getTimeZones();

type Props = {}

const Archive_Config_Options = [30, 60, 90]

const GeneralComponent = (props: Props) => {
    const { mode, toggleTheme } = useThemeContext();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const Settings: SettingsModel = useSelector(selector.settingsObj)
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow)
    const UserPlanTracker: UserPlanTracker = useSelector(selector.userPlanTracker)
    const ArchiveConfigurableDaysSetting: ArchiveConfigurableDaysSetting = useSelector(selector.ArchiveConfigurableDaysSetting)


    const [timeZone, setTimeZone] = useState<TimeZoneModel>(Settings?.Settings?.find(x => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString().toLowerCase() === "true" ? UtilityService.getDefaultTimeZone() : (Settings && Settings?.Settings?.length > 0 && mapToTimeZoneModel(Settings?.Settings?.find(x => x.Code === SettingsService.Time_Zone_Code)?.Value?.toString() || "")) || UtilityService.getDefaultTimeZone())
    const [initialIsChecked, setInitialIsChecked] = useState<boolean>(
        Settings?.Settings?.find((x) => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString().toLowerCase() === "true"
    );

    const [isChecked, setIsChecked] = useState<boolean>(initialIsChecked);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<string>()
    const SettingsData: Setting[] = useSelector(selector.settings)
    const SettingsObj: SettingsModel = useSelector(selector.settingsObj)
    const [showDialogue, setShowDialogue] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [switchType, setSwitchType] = useState<string>("");
    const [ButtonName, setButtonName] = useState<string>("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [mbValue, setMbValue] = useState<string>(((Number(Settings?.Settings?.find(x => x.Code === SettingsService.Media_Size_Limit)?.Value) || 3.5 * 1048576) / 1048576).toString());
    const [mbError, setMbError] = useState<string>("");
    const [isEnableStorageButton, setIsEnableStorageButton] = useState<boolean>(false)
    const [isMbLoading, setIsMbLoading] = useState<boolean>(false)
    const [selectedFeature, setSelectedFeature] = useState<any>(null);
    const [isSecureChatLinkIncludeEnable, setIsSecureChatLinkIncludeEnable] = useState<boolean>(false)
    const [showSecureChatLinkIncludeInNotifyMessageDialog, setShowSecureChatLinkIncludeInNotifyMessageDialog] = useState<boolean>(false)
    const [archiveConfiDays, setArchiveConfigDays] = useState<number>(ArchiveConfigurableDaysSetting?.NumberOfDays);
    const [archiveConfigDaysEnabled, setArchiveConfigDaysEnabled] = useState<boolean>(ArchiveConfigurableDaysSetting?.IsEnabled)
    const [showArchiveConfigDaysDialog, setShowArchiveConfigDaysDialog] = useState<boolean>(false)

    useEffect(() => {
        if (!ArchiveConfigurableDaysSetting?.OrgId) {
            LoadArchiveConfigurableDaysSetting(dispatch)
        }
        setArchiveConfigDays(ArchiveConfigurableDaysSetting?.IsEnabled ? ArchiveConfigurableDaysSetting?.NumberOfDays : 0)
        setArchiveConfigDaysEnabled(ArchiveConfigurableDaysSetting?.IsEnabled)
    }, [ArchiveConfigurableDaysSetting])

    const formSubmit = (e: any) => {
        e.preventDefault();
        if (!errors) {
            setIsLoading(true)
            let setting = Settings?.Settings?.find(
                (x) => x.Code === SettingsService.Time_Zone_Code
            );
            if (setting) {
                setIsLoading(true)
                UpdateSettings(dispatch, {
                    id: setting?.ID,
                    name: setting?.Name,
                    code: setting?.Code,
                    value: timeZone.Name,
                }).then(res => {
                    setIsLoading(false);
                    navigate(AppRoutes.SETTINGS)
                    setToast(ToasterTexts.TIME_ZONE_MESSAGE, ToasterType.SUCCESS);
                    setIsButtonDisabled(true);
                });
            }
            let autoTimezoneSetting = Settings?.Settings?.find(
                (x) => x.Code === SettingsService.Auto_Time_Zone_Code
            );
            if (autoTimezoneSetting) {
                UpdateSettings(dispatch, {
                    id: autoTimezoneSetting?.ID,
                    name: autoTimezoneSetting?.Name,
                    code: autoTimezoneSetting?.Code,
                    value: isChecked.toString(),
                }).then(res => {
                    if (isChecked) {

                    }
                });
            }
        }
        else {
            setIsLoading(false)
        }
    }

    const handleSwitchTimeZone = (change: boolean) => {
        setIsChecked(change)
        setIsButtonDisabled(false);
    }

    const handleOnchange = (event: any, value: any | null) => {
        if (value) {
            setTimeZone({ ...value } as TimeZoneModel)
            setErrors("")
            setIsButtonDisabled(false);
        }
        else {
            setTimeZone({ ...value } as TimeZoneModel)
            setErrors("Time Zone cannot be blank")
        }
    }

    const handleCancel = () => {
        setTimeZone(timeZone);
        setIsChecked(initialIsChecked)
        setIsButtonDisabled(true);
    };

    const handleSwitch = (checked: boolean, type: string) => {
        let text = "";
        if (type === SettingsService.Voice_Otp_Veification) {
            text = checked
                ? appNote.VOICE_VERIFICATION_ENABLE_MESSAGE
                : appNote.VOICE_VERIFICATION_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.Block_MMS_Code) {
            text = checked
                ? appNote.BLOCK_MMS_ENABLE_MESSAGE
                : appNote.BLOCK_MMS_DISABLE_MESSAGE;
        } else if (type === SettingsService.Block_Links_Code) {
            text = checked
                ? appNote.BLOCK_LINKS_ENABLE_MESSAGE
                : appNote.BLOCK_LINKS_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.Unsubscribe_Organization_All_PhoneNumbers) {
            text = checked ? appNote.UNSUBSCRIBE_ENABLE_MESSAGE
                : appNote.UNSUBSCRIBE_DISABLE_MESSAGE
        }
        else if (type === SettingsService.Enable_Ai_Features) {
            text = checked
                ? appNote.AI_FEATURES_ENABLE_MESSAGE
                : appNote.AI_FEATURES_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.OptInCollect) {
            text = checked
                ? appNote.OPTIN_COLLECT_ENABLE_MESSAGE
                : appNote.OPTIN_COLLECT_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.UnArchive) {
            text = checked
                ? appNote.ARCHIVED_ENABLE_MESSAGE
                : appNote.ARCHIVED_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.Switch_PhoneNumber_Alert) {
            text = checked
                ? appNote.SWITCH_PHONENUMBER_ENABLE_MESSAGE
                : appNote.SWITCH_PHONENUMBER_DISABLE_MESSAGE;
        }
        else if (type === SettingsService.Clear_phonenumber_data) {
            text = checked
                ? appNote.CLEAR_PHONENUMBER_DATA_ENABLE_MESSAGE
                : appNote.CLEAR_PHONENUMBER_DATA_DISABLE_MESSAGE;
        }
        else {
            text = checked
                ? appNote.FACTOR_ENABLE_DISPLAY
                : appNote.FACTOR_DISABLE_DISPLAY;
        }
        openConfirmDialog(text, checked ? ActionLabels.ENABLE : ActionLabels.DISABLE, type);
    }

    const openConfirmDialog = (text: any, action: string, type: string) => {
        var user = JSON.parse(localStorage.getItem("current-user")?.toString()!);
        LoadOrgName(dispatch, user.organizationId);
        setShowDialogue(true)
        setText(text)
        setButtonName(action)
        setSwitchType(type)
        setIsLoading(false)
        setSelectedFeature(Settings?.Settings?.find((x) => x.Code === type))
    }

    const closeConfirmDialog = (isConfirm: boolean) => {
        let btnLabel = ButtonName;
        if (isConfirm) {
            UpdateSettings(dispatch, {
                id: selectedFeature?.ID,
                name: selectedFeature?.Name,
                code: selectedFeature?.Code,
                value: btnLabel === ActionLabels.ENABLE ? "true" : "false",
            });
            if (selectedFeature?.Code === SettingsService.Unsubscribe_Organization_All_PhoneNumbers) {
                setToast(btnLabel === ActionLabels.ENABLE ? ToasterTexts.UNSUBSCRIBE_ORG_ALL_PHONENUMBERS_ENABLE : ToasterTexts.UNSUBSCRIBE_ORG_ALL_PHONENUMBERS_DISABLE, ToasterType.SUCCESS);
            } else {
                setToast(selectedFeature.Name + " is " + btnLabel + "d!", ToasterType.SUCCESS);
            }
            setShowDialogue(false)

        }
        setShowDialogue(false)
    };

    const handleValueChange = (count: number) => {
        let setting = SettingsData.find(
            (x) => x.Code === SettingsService.Wrong_Password_Attmps_Code
        );
        if (setting) {
            UpdateSettings(dispatch, {
                id: setting?.ID,
                name: setting?.Name,
                code: setting?.Code,
                value: count.toString(),
            });
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        if (/^\d*\.?\d*$/.test(val)) {
            const num = parseFloat(val);
            if (val === "" || isNaN(num)) {
                setMbValue(val);
                setMbError("");
                return;
            }
            if (num < 0) {
                setMbError("Value cannot be below 0 MB");
            } else if (num > 3.5) {
                setMbError("Value cannot exceed 3.5 MB");
            } else {
                setMbError("");
            }
            setMbValue(val);
            setIsEnableStorageButton(true)
        }
    };

    const handleToCancelMb = () => {
        setIsEnableStorageButton(false)
        setMbValue(((Number(Settings?.Settings?.find(x => x.Code === SettingsService.Media_Size_Limit)?.Value) || 3.5 * 1048576) / 1048576).toString())
        setMbError("")
    }

    const handleToSaveMb = () => {
        let setting = Settings?.Settings?.find((x) => x.Code === SettingsService.Media_Size_Limit);
        if (setting) {
            setIsMbLoading(true)
            UpdateSettings(dispatch, {
                id: setting?.ID,
                name: setting?.Name,
                code: setting?.Code,
                value: parseFloat(mbValue) * 1024 * 1024,
            }).then(res => {
                setIsMbLoading(false);
                navigate(AppRoutes.SETTINGS)
                setToast(ToasterTexts.MEDIA_SIZE_LIMIT, ToasterType.SUCCESS);
                setIsEnableStorageButton(false)
            }).catch((err) => { })
        }
    }
    const handleThemeChange = (event: any) => {
        let setting = Settings?.Settings?.find((x) => x.Code === "THEME");

        UpdateSettings(dispatch, {
            id: setting?.ID,
            name: setting?.Name,
            code: setting?.Code,
            value: event.target.value.toString().toLowerCase(),
        })

        toggleTheme(event.target.value as 'light' | 'dark' | 'system')
    }

    const openSecureChatLinkIncludeDialog = (checked: boolean) => {
        setText(checked ? appNote.SECURECHAT_LINK_NOTIFY_ENABLE_MESSAGE : appNote.SECURECHAT_LINK_NOTIFY_DISABLE_MESSAGE)
        setButtonName(checked ? ActionLabels.ENABLE : ActionLabels.DISABLE)
        setIsLoading(false)
        setShowSecureChatLinkIncludeInNotifyMessageDialog(true)
    }

    const closeSecureChatLinkIncluseDialog = (confirm: boolean) => {
        if (confirm) {
            setIsLoading(true)
            const isEnable = ButtonName === ActionLabels.ENABLE
            const data = { "link_enabled": isEnable }
            SettingsService.updateSecureChatLinkIncludeSetting(data).then((res) => {
                setIsSecureChatLinkIncludeEnable(isEnable)
                setToast(`Include secure chat link in notification setting ${isEnable ? "enabled!" : "disabled!"}`, ToasterType.SUCCESS);
            }).catch((err) => {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                setIsSecureChatLinkIncludeEnable(isSecureChatLinkIncludeEnable)
            }).finally(() => {
                setIsLoading(false);
                setButtonName("");
                setText("");
                setShowSecureChatLinkIncludeInNotifyMessageDialog(false)
            })
        }
        else {
            setIsLoading(false);
            setButtonName("");
            setText("");
            setShowSecureChatLinkIncludeInNotifyMessageDialog(false)
            setIsSecureChatLinkIncludeEnable(isSecureChatLinkIncludeEnable)
        }
    }

    useEffect(() => {
        SettingsService.getSecureChatLinkIncludeSetting().then((res) => {
            setIsSecureChatLinkIncludeEnable(res.data.link_enabled)
        }).catch((err) => {

        })
    }, [])

    const archiveConfigDaysSwitch = (checked: boolean) => {
        if (checked) {
            setArchiveConfigDays(60)
            setArchiveConfigDaysEnabled(true)
            setText(appNote.ARCHIVE_CONFIGURABLE_ENABME_MESSAGE)
            setButtonName(ActionLabels.ENABLE)
            setShowArchiveConfigDaysDialog(true)
        }
        else {
            setArchiveConfigDays(0)
            setArchiveConfigDaysEnabled(false)
            setText(appNote.ARCHIVE_CONFIGURABLE_DISABLE_MESSAGE)
            setButtonName(ActionLabels.DISABLE)
            setShowArchiveConfigDaysDialog(true)
        }
    }

    const openArchiveConfigurableDaysDialog = (option: number) => {
        setArchiveConfigDays(option)
        setArchiveConfigDaysEnabled(true)
        setText(`Are you sure you want to modify conversation archiving after the ${option} days?`)
        setButtonName("Save")
        setShowArchiveConfigDaysDialog(true)
    }

    const closeArchiveConfigurableDyasDialog = () => {
        setShowArchiveConfigDaysDialog(false)
        setText("");
        setButtonName("")
        setArchiveConfigDaysEnabled(ArchiveConfigurableDaysSetting?.IsEnabled)
        setArchiveConfigDays(ArchiveConfigurableDaysSetting?.IsEnabled ? ArchiveConfigurableDaysSetting?.NumberOfDays : 0)
    }

    const updateArchiveConfigurableDays = () => {
        setIsLoading(true)
        const data = {
            isEnabled: archiveConfigDaysEnabled,
            orgId: UserService.getCurrentUserOrgId(),
            numberofDays: archiveConfigDaysEnabled ? archiveConfiDays : 60,
        }
        SettingsService.updateArchiveConfigurableDaysSetting(data).then((res) => {
            setShowArchiveConfigDaysDialog(false)
            setIsLoading(false)
            setText("");
            setButtonName("")
            setToast(ButtonName === ActionLabels.ENABLE ? ToasterTexts.ARCHIVE_CONFIGURABLE_DAYS_SETTING_ENABLE : ButtonName === "Save" ? "Auto-Archive Inactive Conversations is updated" : ToasterTexts.ARCHIVE_CONFIGURABLE_DAYS_SETTING_DISABLE, ToasterType.SUCCESS)
        }).catch((err) => {
            closeArchiveConfigurableDyasDialog()
            setIsLoading(false)
            setShowArchiveConfigDaysDialog(false)
            setText("");
            setButtonName("")
            setToast(err?.response?.data?.message ?? ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
        })
    }

    return (
        <>
            <div className={`m-auto  o-y-scroll h-p-100`}>
                <div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "mt-2"} h-p-15`}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"General"} subTitle={"Your account details"} version={true} />
                </div>
                <div className={`h-p-80 o-y-scroll ${IsMobileDevice ? "" : "px-1"}`}>
                    {!!IsMobileDevice &&
                        <div className="px-3">
                            <Grid container className='pt-1 bb-primary-divider-2'>
                                <Grid item xs={6} className={`t-align-left d-flex align-center`}>
                                    <p className="h3">
                                        Your account details
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={6}>
                                    <span className={`ml-auto`}>
                                        <div className="d-flex align-center" style={{ gap: "6px" }}>
                                            <div className="h4-semibold">
                                                {ViewTextLabels.VERSION}
                                            </div>
                                            <div className="h4-semibold">
                                                {Config.VERSION}
                                            </div>
                                        </div>
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    }
                    {UserService.hasOrgAdminRole() && (
                        <div className={` ${IsMobileDevice ? '' : "settings-border br-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'}  t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.TWO_FACTOR_AUTHENTICATION}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto `}>
                                        <CustomSwitch
                                            checked={SettingsObj.TwoFactAuthEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Two_FactAuth_Code)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {UserService.hasOrgAdminRole() && ((IsNewOrgFlow && UserPlanTracker.HasOrgwideOptout) || !IsNewOrgFlow) && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.ORG_WIDE_OPTOUT_POLICY}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={SettingsObj.UnSubscribeStopEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Unsubscribe_Organization_All_PhoneNumbers)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {UserService.hasOrgAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'}  t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.BLOCK_MMS}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={SettingsObj.BlockIncomingMMSEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Block_MMS_Code)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {UserService.hasOrgAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'}  t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.BLOCK_LINKS}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={SettingsObj.BlockIncomingMessageLinksEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Block_Links_Code)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {!UserService.hasSysAdminRole() && !UserService.hasUserRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'}  t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>Require Opt-in before replying</span>
                                        <div className="h6-regular color-nav-bar-font-color">
                                            When enabled, you can reply to a new contact only after they send an opt-in keyword
                                        </div>
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={Settings?.Settings?.find((x) => x.Code === SettingsService.OptInCollect)?.Value === "true"}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.OptInCollect)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {UserService.hasSysAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3 `}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    {/* <WrongPasswordIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> */}
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.WRONG_PASSWORD_ATTEMPTS}{" "}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center `} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto `}>
                                        <SettingsCounterComponent
                                            onChange={handleValueChange}
                                            count={SettingsObj.AllowedWrongPasswordAttempts}
                                            IsMobileDevice={IsMobileDevice}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )
                    }
                    {UserService.hasSysAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    {/* <TwoFactorIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> */}
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.VOICE_VERIFICATION}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={SettingsObj.VoiceVerificationEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Voice_Otp_Veification)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )
                    }
                    {!UserService.hasSysAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>{Settings?.Settings?.find((x) => x.Code === SettingsService.UnArchive)?.Name}</span>
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={Settings?.Settings?.find((x) => x.Code === SettingsService.UnArchive)?.Value === "true"}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.UnArchive)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {!UserService.hasSysAdminRole() && (
                        <div className={` ${IsMobileDevice ? 'br-2' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>Include secure chat link in notification</span>
                                        <div className="h6-regular color-nav-bar-font-color">
                                            Adds a one-tap link to the secure chat in every secure chat notification.
                                        </div>
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={isSecureChatLinkIncludeEnable}
                                            onChange={(checked: boolean) => openSecureChatLinkIncludeDialog(checked)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )
                    }
                    {!UserService.hasSysAdminRole() &&
                        <div className={` ${IsMobileDevice ? 'br-2' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>Auto-Archive Inactive Conversations</span>
                                        <div className="h6-regular color-nav-bar-font-color">
                                            Automatically archive a conversation when there is no new inbound message from that number for the selected period.
                                        </div>
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={archiveConfigDaysEnabled}
                                            onChange={(checked: boolean) => archiveConfigDaysSwitch(checked)}
                                        />
                                    </span>
                                </Grid>
                                <Grid item xs={12} md={12} xl={12} className="color-settings-items-heading h5-medium">
                                    Archive after no inbound message for
                                </Grid>
                                <Grid item className="d-flex RichEditor-root-border br-3 mb-2 p-1 bg-color-secondary">
                                    {Archive_Config_Options.map(x => <div className={`pl-3 h4-regular color-priamry-accent d-flex align-center p-1 c-pointer ${archiveConfiDays === x ? "bg-color-primary-light color-lite-dark-white" : "color-priary-accent"} br-2 ${ArchiveConfigurableDaysSetting?.IsEnabled ? "" : "disabled"}`} onClick={() => openArchiveConfigurableDaysDialog(x)} >
                                        <span className="h3-medium">{x}</span>
                                        <span className={`ml-1  h4-regular ${archiveConfiDays === x ? "bg-color-primary-light color-lite-dark-white" : "color-text-field-label"}`}>days</span>
                                    </div>)}
                                </Grid>
                            </Grid>
                        </div>
                    }
                    {!UserService.hasSysAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>{Settings?.Settings?.find((x) => x.Code === SettingsService.Switch_PhoneNumber_Alert)?.Name}</span>
                                        {/* <div className="h6-regular color-nav-bar-font-color">
                                            When enabled, you can reply to a new contact only after they send an opt-in keyword
                                        </div> */}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={Settings?.Settings?.find((x) => x.Code === SettingsService.Switch_PhoneNumber_Alert)?.Value === "true"}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Switch_PhoneNumber_Alert)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {!UserService.hasSysAdminRole() && !UserService.hasUserRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                            <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 10} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        <span>{"Allow phone number data to be deleted with a user"}</span>
                                        <div className="h6-regular color-nav-bar-font-color">
                                            When on, admins removing a user can also choose to permanently delete the contacts, conversations, and message history for the phone number assigned to that user. When off, deleting a user never removes number data, and the number can be reassigned with its history intact.
                                        </div>
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 2}>
                                    <span className={`ml-auto`}>
                                        <CustomSwitch
                                            checked={Settings?.Settings?.find((x) => x.Code === SettingsService.Clear_phonenumber_data)?.Value === "true"}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Clear_phonenumber_data)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    <div className={`${IsMobileDevice ? 'mt-1' : "settings-border br-2 mt-2"} px-3`}>
                        <Grid container className={`${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                            <Grid item xs={IsMobileDevice ? 8 : 8} className={`${IsMobileDevice ? '' : ' py-1'} t-align-left d-flex align-center`}>
                                <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                    Dark Mode
                                </p>
                            </Grid>
                            <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 4 : 4}>
                                <FormControl fullWidth size="small" className="ml-auto">
                                    <InputLabel id="theme-mode-label">Theme Mode</InputLabel>
                                    <Select
                                        labelId="theme-mode-label"
                                        id="theme-mode-select"
                                        value={mode}
                                        label="Theme Mode"
                                        onChange={(event) => handleThemeChange(event)}

                                    >
                                        <MenuItem value="light">🌞 Light</MenuItem>
                                        <MenuItem value="dark">🌙 Dark</MenuItem>
                                        <MenuItem value="system">🖥️ Browser Default</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={`${IsMobileDevice ? '' : "settings-border br-2 mt-2"} px-3`}>
                        {IsMobileDevice ?
                            <Grid container className="py-3">
                                <Grid item className="t-align-left  my-auto">
                                    <Typography className="h2-semibold t-align-left">
                                        Select your relevant time zone
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <hr className="bb-primary-divider-2 opacity-1 mt-1 mb-2 w-p-100" />
                                </Grid>
                                <Grid item className="b-none my-auto d-flex align-center justify-between w-p-100" style={{ gap: "20px" }}>
                                    <Typography className={`${IsMobileDevice ? "h2" : "h5-medium"} t-align-left`}>
                                        {appNote.SET_TIME_ZONE}
                                    </Typography>
                                    <CustomSwitch
                                        checked={isChecked}
                                        onChange={(checked: boolean) => handleSwitchTimeZone(checked)}
                                    />
                                </Grid>
                            </Grid>
                            :
                            <Grid container className="py-3">
                                <Grid item className="t-align-left d-flex  py-1 my-auto">
                                    <Typography className="h4-medium t-align-left">
                                        Select your relevant time zone
                                    </Typography>
                                </Grid>
                                <Grid item className="b-none my-auto ml-auto d-flex align-center" style={{ gap: "20px" }}>
                                    <Typography className="h5-medium t-align-left">
                                        {appNote.SET_TIME_ZONE}
                                    </Typography>
                                    <CustomSwitch
                                        checked={isChecked}
                                        onChange={(checked: boolean) => handleSwitchTimeZone(checked)}
                                    />
                                </Grid>
                            </Grid>
                        }
                        <form onSubmit={formSubmit}>
                            {<Grid container className={`pb-3 ${IsMobileDevice ? "bb-primary-divider-2" : ""}`}>
                                <Autocomplete
                                    size="small"
                                    className={`${isChecked ? "w-fill Mui-disabled" : "w-fill"}`}
                                    classes={{ input: ` color-text-field-font `, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={timeZonesTypes}
                                    disabled={isChecked}
                                    getOptionLabel={(option: TimeZoneModel) => option && option.OffsetLabel && option.Name ? `(${option.OffsetLabel}) ${option.Name}` : ""}
                                    onChange={handleOnchange}
                                    value={isChecked ? UtilityService.getDefaultTimeZone() : timeZonesTypes.find(x => x.Name === timeZone?.Name)}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops} data-name={option.Name} className={`c-pointercolor-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                            ({option.OffsetLabel}) {option.Name}
                                        </li>
                                    )}
                                    defaultValue={timeZone?.Name}
                                    onOpen={() => {
                                        setTimeout(() => {
                                            const element = document.querySelector(
                                                `[data-name="${timeZone.Name}"]`
                                            );
                                            element?.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });

                                        }, 0);
                                    }}
                                    renderInput={(params) => <TextField {...params} name="Time Zone" variant="outlined" label="Time Zone" placeholder="Time Zone" />}
                                />
                                <FormHelperText className="h5 color-primary-danger ml-auto">
                                    {errors}
                                </FormHelperText>
                                {<Grid item xs={12} className={`d-flex mt-3 ${IsMobileDevice ? '' : 'justify-flex-end'}`} >
                                    <ButtonComponent
                                        Variant={isButtonDisabled ? "disabled-btn-small" : "secondary-btn-small"}
                                        ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : ''}`}
                                        OnClick={handleCancel}
                                        ButtonLabel={buttonLabels.CANCEL}
                                    />
                                    <ButtonComponent
                                        Variant={isButtonDisabled ? "disabled-btn-small" : "primary-btn-small"}
                                        ClassName={`c-pointer w-space ${IsMobileDevice ? 'w-100' : ''}`}
                                        Type={"submit"}
                                        ButtonLabel={buttonLabels.SAVE}
                                        Loading={isLoading}
                                    />
                                </Grid>}
                            </Grid>}
                        </form>
                    </div>
                    {/* {UserService.hasOrgAdminRole() && !IsMobileDevice && (
                        <div className={`${IsMobileDevice ? '' : IsDarkMode ? "RichEditor-root-border br-2" : 'schedule-report-border br-2'} mt-2`}>
                            <Grid container className={` `}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'} pl-3 t-align-left d-flex align-center`}>
                                    <p className={`${IsMobileDevice ? "h2" : "h5-medium"} color-settings-items-heading t-align-left`}>
                                        {ViewTextLabels.ENABLE_AI_FEATURES}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto mr-3`}>
                                        <CustomSwitch
                                            checked={SettingsObj.AiFeaturesEnabled}
                                            onChange={(checked: boolean) => handleSwitch(checked, SettingsService.Enable_Ai_Features)}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    )
                    } */}

                    {UserService.hasOrgAdminRole() && (
                        <div className={`${IsMobileDevice ? '' : "settings-border br-2"} mt-2 `}>
                            <Grid container className={`${mbError ? "mt-2" : ""}`}>
                                <Grid item xs={IsMobileDevice ? 9 : 8} className={`${IsMobileDevice ? '' : ' py-1'}  t-align-left d-flex align-center pl-3`}>
                                    {/* <TwoFactorIcon className={`${IsMobileDevice ? "" : ""} w-4 mr-2`} /> */}
                                    <p className={`${IsMobileDevice ? "h3" : "h4-medium"} color-settings-items-heading t-align-left`}>
                                        {"Media Storage Limit"}
                                    </p>
                                </Grid>
                                <Grid item className={`b-none d-flex my-auto justify-center pr-3`} xs={IsMobileDevice ? 3 : 4}>
                                    <span className={`ml-auto `}>

                                        <TextField
                                            className="right-align-textfield-error"
                                            label="File size limit (MB)"
                                            value={mbValue}
                                            size="small"
                                            onChange={handleChange}
                                            error={!!mbError}
                                            helperText={mbError}
                                            inputProps={{
                                                inputMode: "decimal"
                                            }}
                                        />
                                    </span>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={`d-flex mb-2 mr-3 ${IsMobileDevice ? 'ml-3' : 'justify-flex-end'}`} >
                                <ButtonComponent
                                    Variant={isEnableStorageButton ? "secondary-btn-small" : "disabled-btn-small"}
                                    ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : ''}`}
                                    OnClick={handleToCancelMb}
                                    ButtonLabel={buttonLabels.CANCEL}
                                />
                                <ButtonComponent
                                    Variant={((isEnableStorageButton) && !!mbValue && !mbError) ? "primary-btn-small" : "disabled-btn-small"}
                                    ClassName={`c-pointer w-space ${IsMobileDevice ? 'w-100' : ''}`}
                                    ButtonLabel={buttonLabels.SAVE}
                                    Loading={isMbLoading}
                                    OnClick={handleToSaveMb}
                                />
                            </Grid>
                        </div>
                    )
                    }
                </div>

                <ConfirmDialog
                    onClose={closeConfirmDialog}
                    Show={showDialogue}
                    Text={text}
                    ButtonName={ButtonName}
                    Loading={isLoading}
                    IsMobileDevice={IsMobileDevice}
                />
                {showSecureChatLinkIncludeInNotifyMessageDialog &&
                    <ConfirmDialog
                        onClose={closeSecureChatLinkIncluseDialog}
                        Show={showSecureChatLinkIncludeInNotifyMessageDialog}
                        Text={text}
                        ButtonName={ButtonName}
                        Loading={isLoading}
                        IsMobileDevice={IsMobileDevice}
                    />
                }

                {
                    <Dialog
                        maxWidth="sm"
                        fullWidth={true}
                        BackdropProps={IsMobileDevice ? {} : { style: { backgroundColor: "transparent" } }}
                        open={showArchiveConfigDaysDialog}
                        onClose={() => { closeArchiveConfigurableDyasDialog() }}
                        classes={{ paper: `br-3 ${IsDarkMode ? "" : 'dialogue-shadow'}` }}
                    >
                        <DialogTitle className='bg-color-primary-background'>
                            <div className='d-flex justify-between align-center mt-1'>
                                <span className='d-flex align-center'>
                                    <span className='h3-semibold color-secure-file-dialog-title'>
                                        Confirm
                                    </span>
                                </span>
                                <CancelIcon onClick={() => { closeArchiveConfigurableDyasDialog() }} className="c-pointer" />
                            </div>
                        </DialogTitle>
                        <DialogContent className={` ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                            <div className="h4-regular color-menu-list-font-color" >
                                {text}
                            </div>
                            {!ArchiveConfigurableDaysSetting?.IsEnabled &&
                                <div>
                                    <div className="color-settings-items-heading h3-medium mt-2">
                                        Archive after
                                    </div>
                                    {!IsMobileDevice ? <div className="d-flex">
                                        <div className={`d-flex RichEditor-root-border br-3 mb-2 p-1 bg-color-secondary mt-2`}>
                                            {Archive_Config_Options.map(x => <div className={` h4-regular color-priamry-accent d-flex align-center p-1 c-pointer ${archiveConfiDays === x ? "bg-color-primary-light color-lite-dark-white" : "color-priary-accent"} br-2`} onClick={() => setArchiveConfigDays(x)}>
                                                <span className="h3-medium">{x}</span>
                                                <span className={`ml-1 h4-regular ${archiveConfiDays === x ? "bg-color-primary-light color-lite-dark-white" : "color-text-field-label"}`}>days</span>
                                            </div>)}
                                        </div>
                                    </div> :
                                        <RadioGroup
                                            // row
                                            value={archiveConfiDays}
                                            sx={{
                                                "& .MuiRadio-root": {
                                                    padding: "4px",
                                                    marginLeft: "16px"
                                                },
                                            }}
                                            onChange={(e) => setArchiveConfigDays(Number(e.target.value))}
                                        >
                                            <FormControlLabel value="30" control={<Radio />} label="30 Days" />
                                            <FormControlLabel value="60" control={<Radio />} label="60 Days" />
                                            <FormControlLabel value="90" control={<Radio />} label="90 Days" />
                                        </RadioGroup>
                                    }
                                </div>
                            }
                        </DialogContent>
                        <DialogActions className={`pb-2 ${IsDarkMode ? "bg-color-sidebar-bg" : ""}`}>
                            <ButtonComponent OnClick={(e) => closeArchiveConfigurableDyasDialog()} ButtonLabel={buttonLabels.CANCEL} ClassName={"c-pointer"} Variant={"secondary-btn-small"} />
                            <ButtonComponent OnClick={(e) => { updateArchiveConfigurableDays() }} ButtonLabel={ButtonName} ClassName={"c-pointer mr-1"} Variant={"primary-btn-small"} Loading={isLoading} />
                        </DialogActions>

                    </Dialog>
                }
            </div>
        </>
    )
}

export default GeneralComponent